import React from "react";
import { useLanguage } from "../context/LanguageContext";

export const Footer = () => {
    const { t } = useLanguage();
    const links = [
        { key: "nav.cases", href: "#cases" },
        { key: "nav.skills", href: "#skills" },
        { key: "nav.about", href: "#top" },
        { label: "Connect", href: "#contact" },
    ];
    return (
        <footer
            id="journal"
            data-testid="site-footer"
            className="relative"
            style={{
                background: "var(--ink)",
                color: "var(--paper)",
            }}
        >
            <div className="max-w-[1320px] mx-auto px-6 lg:px-12 py-16">
                <div className="grid lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-7">
                        <div
                            className="font-serif-display text-[24px]"
                            style={{ color: "var(--peach)" }}
                        >
                            Charlyn{" "}
                            <span className="italic">De Wulf</span>
                        </div>
                        <h3 className="font-serif-display text-[44px] sm:text-[56px] mt-4 leading-[1.02]">
                            {t("footer.tag.a")}
                            <br />
                            <span
                                className="italic"
                                style={{ color: "var(--peach)" }}
                            >
                                {t("footer.tag.b")}
                            </span>
                        </h3>
                        <p
                            className="mt-6 max-w-[440px] text-[14.5px] leading-[1.65]"
                            style={{ color: "rgba(250,245,236,0.7)" }}
                        >
                            {t("footer.tag.body")}
                        </p>
                    </div>

                    <div className="lg:col-span-5">
                        <div
                            className="font-mono-archive text-[10px] mb-5"
                            style={{ color: "rgba(250,245,236,0.55)" }}
                        >
                            {t("footer.navigate")}
                        </div>
                        <ul className="space-y-3">
                            {links.map((l) => (
                                <li key={l.key || l.label}>
                                    <a
                                        href={l.href}
                                        data-testid={`footer-${(l.key ? l.key.split(".")[1] : l.label).toLowerCase()}`}
                                        className="font-serif-display text-[20px] italic archive-link"
                                        style={{ color: "var(--paper)" }}
                                    >
                                        {l.key ? t(l.key) : l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div
                    className="mt-16 pt-8 flex flex-wrap items-center justify-between gap-4"
                    style={{}}
                >
                    <span
                        className="font-mono-archive text-[10px]"
                        style={{ color: "rgba(250,245,236,0.55)" }}
                    >
                        {t("footer.copy")}
                    </span>
                    <span
                        className="font-mono-archive text-[10px]"
                        style={{ color: "rgba(250,245,236,0.55)" }}
                    >
                        {t("footer.set")}
                    </span>
                </div>
            </div>
        </footer>
    );
};
